import {Bookings} from "../model/Bookings";
import {TipSummary} from "../model/TipSummary";

export default (bookings:Bookings):TipSummary => {
  if(!bookings){
    return {};
  }
  const result:TipSummary = {};
  const technicians = Object.keys(bookings);
  technicians.forEach(technician => {
    if(bookings[technician].slots){
      const slotKeys = Object.keys(bookings[technician].slots);
      slotKeys.forEach(key => {
        const slot = bookings[technician].slots[key];
        if(slot.tips){
          slot.tips.forEach(tip => {
            if(result[tip.to]){
              result[tip.to] += tip.amount;
            }else{
              result[tip.to] = tip.amount;
            }
          });
        }
      });
    }
  });
  return result;
};
